export interface SsmCurrency {
  code: string;
  description: string;
}

export const SSM_CURRENCIES: SsmCurrency[] = [
  { code: 'AFN', description: 'Afghanistan Afghani (AFN)' },
  { code: 'ALL', description: 'Albania Lek (ALL)' },
  { code: 'DZD', description: 'Algeria Dinar (DZD)' },
  { code: 'AOA', description: 'Angola Kwanza (AOA)' },
  { code: 'ARS', description: 'Argentina Peso (ARS)' },
  { code: 'AMD', description: 'Armenia Dram (AMD)' },
  { code: 'AWG', description: 'Aruba Guilder (AWG)' },
  { code: 'AUD', description: 'Australia Dollar (AUD)' },
  { code: 'AZN', description: 'Azerbaijan Manat (AZN)' },
  { code: 'BSD', description: 'Bahamas Dollar (BSD)' },
  { code: 'BHD', description: 'Bahrain Dinar (BHD)' },
  { code: 'BDT', description: 'Bangladesh Taka (BDT)' },
  { code: 'BBD', description: 'Barbados Dollar (BBD)' },
  { code: 'BYN', description: 'Belarus Ruble (BYN)' },
  { code: 'BZD', description: 'Belize Dollar (BZD)' },
  { code: 'BMD', description: 'Bermuda Dollar (BMD)' },
  { code: 'BTN', description: 'Bhutan Ngultrum (BTN)' },
  { code: 'BOB', description: 'Bolivia Bolíviano (BOB)' },
  { code: 'BAM', description: 'Bosnia and Herzegovina Convertible Marka (BAM)' },
  { code: 'BWP', description: 'Botswana Pula (BWP)' },
  { code: 'BRL', description: 'Brazil Real (BRL)' },
  { code: 'BND', description: 'Brunei Darussalam Dollar (BND)' },
  { code: 'BGN', description: 'Bulgaria Lev (BGN)' },
  { code: 'BIF', description: 'Burundi Franc (BIF)' },
  { code: 'KHR', description: 'Cambodia Riel (KHR)' },
  { code: 'CAD', description: 'Canada Dollar (CAD)' },
  { code: 'CVE', description: 'Cape Verde Escudo (CVE)' },
  { code: 'KYD', description: 'Cayman Islands Dollar (KYD)' },
  { code: 'CLP', description: 'Chile Peso (CLP)' },
  { code: 'CNY', description: 'China Yuan Renminbi (CNY)' },
  { code: 'COP', description: 'Colombia Peso (COP)' },
  { code: 'XOF', description: 'Communauté Financière Africaine (BCEAO) Franc (XOF)' },
  { code: 'XAF', description: 'Communauté Financière Africaine (BEAC) CFA Franc BEAC (XAF)' },
  { code: 'KMF', description: 'Comorian Franc (KMF)' },
  { code: 'XPF', description: 'Comptoirs Français du Pacifique (CFP) Franc (XPF)' },
  { code: 'CDF', description: 'Congo/Kinshasa Franc (CDF)' },
  { code: 'CRC', description: 'Costa Rica Colon (CRC)' },
  { code: 'HRK', description: 'Croatia Kuna (HRK)' },
  { code: 'CUC', description: 'Cuba Convertible Peso (CUC)' },
  { code: 'CUP', description: 'Cuba Peso (CUP)' },
  { code: 'CZK', description: 'Czech Republic Koruna (CZK)' },
  { code: 'DKK', description: 'Denmark Krone (DKK)' },
  { code: 'DJF', description: 'Djibouti Franc (DJF)' },
  { code: 'DOP', description: 'Dominican Republic Peso (DOP)' },
  { code: 'XCD', description: 'East Caribbean Dollar (XCD)' },
  { code: 'EGP', description: 'Egypt Pound (EGP)' },
  { code: 'SVC', description: 'El Salvador Colon (SVC)' },
  { code: 'ERN', description: 'Eritrea Nakfa (ERN)' },
  { code: 'ETB', description: 'Ethiopia Birr (ETB)' },
  { code: 'EUR', description: 'Euro Member Countries (EUR)' },
  { code: 'FKP', description: 'Falkland Islands (Malvinas) Pound (FKP)' },
  { code: 'FJD', description: 'Fiji Dollar (FJD)' },
  { code: 'GMD', description: 'Gambia Dalasi (GMD)' },
  { code: 'GEL', description: 'Georgia Lari (GEL)' },
  { code: 'GHS', description: 'Ghana Cedi (GHS)' },
  { code: 'GIP', description: 'Gibraltar Pound (GIP)' },
  { code: 'GTQ', description: 'Guatemala Quetzal (GTQ)' },
  { code: 'GGP', description: 'Guernsey Pound (GGP)' },
  { code: 'GNF', description: 'Guinea Franc (GNF)' },
  { code: 'GYD', description: 'Guyana Dollar (GYD)' },
  { code: 'HTG', description: 'Haiti Gourde (HTG)' },
  { code: 'HNL', description: 'Honduras Lempira (HNL)' },
  { code: 'HKD', description: 'Hong Kong Dollar (HKD)' },
  { code: 'HUF', description: 'Hungary Forint (HUF)' },
  { code: 'ISK', description: 'Iceland Krona (ISK)' },
  { code: 'INR', description: 'India Rupee (INR)' },
  { code: 'IDR', description: 'Indonesia Rupiah (IDR)' },
  { code: 'XDR', description: 'International Monetary Fund (IMF) Special Drawing Rights (XDR)' },
  { code: 'IRR', description: 'Iran Rial (IRR)' },
  { code: 'IQD', description: 'Iraq Dinar (IQD)' },
  { code: 'IMP', description: 'Isle of Man Pound (IMP)' },
  { code: 'JMD', description: 'Jamaica Dollar (JMD)' },
  { code: 'JPY', description: 'Japan Yen (JPY)' },
  { code: 'JEP', description: 'Jersey Pound (JEP)' },
  { code: 'JOD', description: 'Jordan Dinar (JOD)' },
  { code: 'KZT', description: 'Kazakhstan Tenge (KZT)' },
  { code: 'KES', description: 'Kenya Shilling (KES)' },
  { code: 'KPW', description: 'Korea (North) Won (KPW)' },
  { code: 'KRW', description: 'Korea (South) Won (KRW)' },
  { code: 'KWD', description: 'Kuwait Dinar (KWD)' },
  { code: 'KGS', description: 'Kyrgyzstan Som (KGS)' },
  { code: 'LAK', description: 'Laos Kip (LAK)' },
  { code: 'LBP', description: 'Lebanon Pound (LBP)' },
  { code: 'LSL', description: 'Lesotho Loti (LSL)' },
  { code: 'LRD', description: 'Liberia Dollar (LRD)' },
  { code: 'LYD', description: 'Libya Dinar (LYD)' },
  { code: 'MOP', description: 'Macau Pataca (MOP)' },
  { code: 'MKD', description: 'Macedonia Denar (MKD)' },
  { code: 'MGA', description: 'Madagascar Ariary (MGA)' },
  { code: 'MWK', description: 'Malawi Kwacha (MWK)' },
  { code: 'MYR', description: 'Malaysian Ringgit (MYR)' },
  { code: 'MVR', description: 'Maldives (Maldive Islands) Rufiyaa (MVR)' },
  { code: 'MRO', description: 'Mauritania Ouguiya (MRO)' },
  { code: 'MUR', description: 'Mauritius Rupee (MUR)' },
  { code: 'MXN', description: 'Mexico Peso (MXN)' },
  { code: 'MDL', description: 'Moldova Leu (MDL)' },
  { code: 'MMK', description: 'Myanmar (Burma) Kyat (MMK)' },
  { code: 'NAD', description: 'Namibia Dollar (NAD)' },
  { code: 'NPR', description: 'Nepal Rupee (NPR)' },
  { code: 'ANG', description: 'Netherlands Antilles Guilder (ANG)' },
  { code: 'MNT', description: 'Mongolia Tughrik (MNT)' },
  { code: 'MAD', description: 'Morocco Dirham (MAD)' },
  { code: 'MZN', description: 'Mozambique Metical (MZN)' },
  { code: 'NZD', description: 'New Zealand Dollar (NZD)' },
  { code: 'NIO', description: 'Nicaragua Cordoba (NIO)' },
  { code: 'NGN', description: 'Nigeria Naira (NGN)' },
  { code: 'NOK', description: 'Norway Krone (NOK)' },
  { code: 'OMR', description: 'Oman Rial (OMR)' },
  { code: 'PKR', description: 'Pakistan Rupee (PKR)' },
  { code: 'PAB', description: 'Panama Balboa (PAB)' },
  { code: 'PGK', description: 'Papua New Guinea Kina (PGK)' },
  { code: 'PYG', description: 'Paraguay Guarani (PYG)' },
  { code: 'PEN', description: 'Peru Sol (PEN)' },
  { code: 'PHP', description: 'Philippines Peso (PHP)' },
  { code: 'PLN', description: 'Poland Zloty (PLN)' },
  { code: 'QAR', description: 'Qatar Riyal (QAR)' },
  { code: 'RON', description: 'Romania Leu (RON)' },
  { code: 'RUB', description: 'Russia Ruble (RUB)' },
  { code: 'RWF', description: 'Rwanda Franc (RWF)' },
  { code: 'SHP', description: 'Saint Helena Pound (SHP)' },
  { code: 'WST', description: 'Samoa Tala (WST)' },
  { code: 'SAR', description: 'Saudi Arabia Riyal (SAR)' },
  { code: 'SOL', description: 'Seborga Luigino (SPL*)' },
  { code: 'RSD', description: 'Serbia Dinar (RSD)' },
  { code: 'SCR', description: 'Seychelles Rupee (SCR)' },
  { code: 'SLL', description: 'Sierra Leone Leone (SLL)' },
  { code: 'SGD', description: 'Singapore Dollar (SGD)' },
  { code: 'SBD', description: 'Solomon Islands Dollar (SBD)' },
  { code: 'SOS', description: 'Somalia Shilling (SOS)' },
  { code: 'ZAR', description: 'South Africa Rand (ZAR)' },
  { code: 'LKR', description: 'Sri Lanka Rupee (LKR)' },
  { code: 'SDG', description: 'Sudan Pound (SDG)' },
  { code: 'SRD', description: 'Suriname Dollar (SRD)' },
  { code: 'SZL', description: 'Swaziland Lilangeni (SZL)' },
  { code: 'SEK', description: 'Sweden Krona (SEK)' },
  { code: 'CHF', description: 'Switzerland Franc (CHF)' },
  { code: 'SYP', description: 'Syria Pound (SYP)' },
  { code: 'TWD', description: 'Taiwan New Dollar (TWD)' },
  { code: 'TJS', description: 'Tajikistan Somoni (TJS)' },
  { code: 'TZS', description: 'Tanzania Shilling (TZS)' },
  { code: 'THB', description: 'Thailand Baht (THB)' },
  { code: 'TOP', description: "Tonga Pa'anga (TOP)" },
  { code: 'TTD', description: 'Trinidad and Tobago Dollar (TTD)' },
  { code: 'TND', description: 'Tunisia Dinar (TND)' },
  { code: 'TRY', description: 'Turkey Lira (TRY)' },
  { code: 'TMT', description: 'Turkmenistan Manat (TMT)' },
  { code: 'TVD', description: 'Tuvalu Dollar (TVD)' },
  { code: 'UGX', description: 'Uganda Shilling (UGX)' },
  { code: 'UAH', description: 'Ukraine Hryvnia (UAH)' },
  { code: 'AED', description: 'United Arab Emirates Dirham (AED)' },
  { code: 'GBP', description: 'United Kingdom Pound (GBP)' },
  { code: 'USD', description: 'United States Dollar (USD)' },
  { code: 'UYU', description: 'Uruguay Peso (UYU)' },
  { code: 'UZS', description: 'Uzbekistan Som (UZS)' },
  { code: 'VUV', description: 'Vanuatu Vatu (VUV)' },
  { code: 'VEF', description: 'Venezuela Bolivar (VEF)' },
  { code: 'VND', description: 'Viet Nam Dong (VND)' },
  { code: 'YER', description: 'Yemen Rial (YER)' },
  { code: 'ZMW', description: 'Zambia Kwacha (ZMW)' },
  { code: 'ZWD', description: 'Zimbabwe Dollar (ZWD)' },
  { code: 'STD', description: 'Sao Tome and Principe Dobra (STD)' },
];

export const getSsmCurrencyLabel = (code: string): string => {
  if (!code) return '';
  return SSM_CURRENCIES.find((item) => item.code === code)?.description || code;
};
